export default "/images/vendor/flag-icons/flags/4x3/jo.svg?1220fdb3ff197682a44f5e67b2a18262";